'use strict';

var illustrations = require('../../../../../../../../../../_virtual/illustrations.cjs');

var hasRequiredIllustrations;

function requireIllustrations () {
	if (hasRequiredIllustrations) return illustrations.__exports;
	hasRequiredIllustrations = 1;

	var ILLUSTRATION_COMPONENTS = /*#__PURE__*/ function(ILLUSTRATION_COMPONENTS) {
	    ILLUSTRATION_COMPONENTS["AccountEmailMobile"] = "AccountEmailMobile";
	    ILLUSTRATION_COMPONENTS["AccountWeb"] = "AccountWeb";
	    ILLUSTRATION_COMPONENTS["AddAccountMobile"] = "AddAccountMobile";
	    ILLUSTRATION_COMPONENTS["AddPatientWeb"] = "AddPatientWeb";
	    ILLUSTRATION_COMPONENTS["AddSuppsMobile"] = "AddSuppsMobile";
	    ILLUSTRATION_COMPONENTS["AlertAddMobile"] = "AlertAddMobile";
	    ILLUSTRATION_COMPONENTS["AlertMobile"] = "AlertMobile";
	    ILLUSTRATION_COMPONENTS["Announcement"] = "Announcement";
	    ILLUSTRATION_COMPONENTS["Apple"] = "Apple";
	    ILLUSTRATION_COMPONENTS["Arthritis"] = "Arthritis";
	    ILLUSTRATION_COMPONENTS["AutoRefillCalendar"] = "AutoRefillCalendar";
	    ILLUSTRATION_COMPONENTS["AutoRefillCart"] = "AutoRefillCart";
	    ILLUSTRATION_COMPONENTS["AutoRefillDiscount"] = "AutoRefillDiscount";
	    ILLUSTRATION_COMPONENTS["AutoRefillLegacy"] = "AutoRefillLegacy";
	    ILLUSTRATION_COMPONENTS["AutoRefillPackage"] = "AutoRefillPackage";
	    ILLUSTRATION_COMPONENTS["AutoRefillWeb"] = "AutoRefillWeb";
	    ILLUSTRATION_COMPONENTS["BarChart"] = "BarChart";
	    ILLUSTRATION_COMPONENTS["Basket"] = "Basket";
	    ILLUSTRATION_COMPONENTS["Biohazard"] = "Biohazard";
	    ILLUSTRATION_COMPONENTS["BoneDensity"] = "BoneDensity";
	    ILLUSTRATION_COMPONENTS["BuildPlanWeb"] = "BuildPlanWeb";
	    ILLUSTRATION_COMPONENTS["Calendar"] = "Calendar";
	    ILLUSTRATION_COMPONENTS["Cart"] = "Cart";
	    ILLUSTRATION_COMPONENTS["ChatBubbles"] = "ChatBubbles";
	    ILLUSTRATION_COMPONENTS["Checklist"] = "Checklist";
	    ILLUSTRATION_COMPONENTS["Checkmark"] = "Checkmark";
	    ILLUSTRATION_COMPONENTS["Compare"] = "Compare";
	    ILLUSTRATION_COMPONENTS["CreatePlanTemplateWeb"] = "CreatePlanTemplateWeb";
	    ILLUSTRATION_COMPONENTS["CurrentSuppsMobile"] = "CurrentSuppsMobile";
	    ILLUSTRATION_COMPONENTS["Depression"] = "Depression";
	    ILLUSTRATION_COMPONENTS["Events"] = "Events";
	    ILLUSTRATION_COMPONENTS["Exclamation"] = "Exclamation";
	    ILLUSTRATION_COMPONENTS["FsAccountMobile"] = "FsAccountMobile";
	    ILLUSTRATION_COMPONENTS["Gastrointestinal"] = "Gastrointestinal";
	    ILLUSTRATION_COMPONENTS["Germs"] = "Germs";
	    ILLUSTRATION_COMPONENTS["GiftCard"] = "GiftCard";
	    ILLUSTRATION_COMPONENTS["Glucometer"] = "Glucometer";
	    ILLUSTRATION_COMPONENTS["Heart"] = "Heart";
	    ILLUSTRATION_COMPONENTS["Hypothyroidism"] = "Hypothyroidism";
	    ILLUSTRATION_COMPONENTS["ImportPatientListWeb"] = "ImportPatientListWeb";
	    ILLUSTRATION_COMPONENTS["InOfficeCheckoutWeb"] = "InOfficeCheckoutWeb";
	    ILLUSTRATION_COMPONENTS["IntegrativeMed"] = "IntegrativeMed";
	    ILLUSTRATION_COMPONENTS["Integration"] = "Integration";
	    ILLUSTRATION_COMPONENTS["KettleBell"] = "KettleBell";
	    ILLUSTRATION_COMPONENTS["LabResults"] = "LabResults";
	    ILLUSTRATION_COMPONENTS["Loading"] = "Loading";
	    ILLUSTRATION_COMPONENTS["Memory"] = "Memory";
	    ILLUSTRATION_COMPONENTS["MultiPatientAddWeb"] = "MultiPatientAddWeb";
	    ILLUSTRATION_COMPONENTS["MultiPatientPlanWeb"] = "MultiPatientPlanWeb";
	    ILLUSTRATION_COMPONENTS["NavigateWeb"] = "NavigateWeb";
	    ILLUSTRATION_COMPONENTS["Network"] = "Network";
	    ILLUSTRATION_COMPONENTS["Networking"] = "Networking";
	    ILLUSTRATION_COMPONENTS["NotificationMobile"] = "NotificationMobile";
	    ILLUSTRATION_COMPONENTS["OrderHistoryMobile"] = "OrderHistoryMobile";
	    ILLUSTRATION_COMPONENTS["Ovaries"] = "Ovaries";
	    ILLUSTRATION_COMPONENTS["Packed"] = "Packed";
	    ILLUSTRATION_COMPONENTS["PatientAccountMobile"] = "PatientAccountMobile";
	    ILLUSTRATION_COMPONENTS["PatientHistoryMobile"] = "PatientHistoryMobile";
	    ILLUSTRATION_COMPONENTS["PatientPlanWeb"] = "PatientPlanWeb";
	    ILLUSTRATION_COMPONENTS["PatientResources"] = "PatientResources";
	    ILLUSTRATION_COMPONENTS["Payments"] = "Payments";
	    ILLUSTRATION_COMPONENTS["PersonalCare"] = "PersonalCare";
	    ILLUSTRATION_COMPONENTS["PestleMortar"] = "PestleMortar";
	    ILLUSTRATION_COMPONENTS["PlayButton"] = "PlayButton";
	    ILLUSTRATION_COMPONENTS["Pregnancy"] = "Pregnancy";
	    ILLUSTRATION_COMPONENTS["PreMadeTemplate"] = "PreMadeTemplate";
	    ILLUSTRATION_COMPONENTS["PriceTag"] = "PriceTag";
	    ILLUSTRATION_COMPONENTS["Refill"] = "Refill";
	    ILLUSTRATION_COMPONENTS["Search"] = "Search";
	    ILLUSTRATION_COMPONENTS["SecurityWeb"] = "SecurityWeb";
	    ILLUSTRATION_COMPONENTS["ShippingTruck"] = "ShippingTruck";
	    ILLUSTRATION_COMPONENTS["SingleUserWeb"] = "SingleUserWeb";
	    ILLUSTRATION_COMPONENTS["Sleep"] = "Sleep";
	    ILLUSTRATION_COMPONENTS["SmartWatch"] = "SmartWatch";
	    ILLUSTRATION_COMPONENTS["Smoking"] = "Smoking";
	    ILLUSTRATION_COMPONENTS["Social"] = "Social";
	    ILLUSTRATION_COMPONENTS["Stress"] = "Stress";
	    ILLUSTRATION_COMPONENTS["SupplementEd"] = "SupplementEd";
	    ILLUSTRATION_COMPONENTS["SupplementPlanDkIllustration"] = "SupplementPlanDkIllustration";
	    ILLUSTRATION_COMPONENTS["SupplementResources"] = "SupplementResources";
	    ILLUSTRATION_COMPONENTS["Supplements"] = "Supplements";
	    ILLUSTRATION_COMPONENTS["SuppBottle"] = "SuppBottle";
	    ILLUSTRATION_COMPONENTS["Telemedicine"] = "Telemedicine";
	    ILLUSTRATION_COMPONENTS["Testimonial"] = "Testimonial";
	    ILLUSTRATION_COMPONENTS["ThreeSuppBottles"] = "ThreeSuppBottles";
	    ILLUSTRATION_COMPONENTS["Thyroid"] = "Thyroid";
	    ILLUSTRATION_COMPONENTS["TrackOrderMobile"] = "TrackOrderMobile";
	    ILLUSTRATION_COMPONENTS["Unpacked"] = "Unpacked";
	    ILLUSTRATION_COMPONENTS["User"] = "User";
	    ILLUSTRATION_COMPONENTS["Waiting"] = "Waiting";
	    ILLUSTRATION_COMPONENTS["Wellness"] = "Wellness";
	    ILLUSTRATION_COMPONENTS["Wholesale"] = "Wholesale";
	    ILLUSTRATION_COMPONENTS["WholesaleOrderMobile"] = "WholesaleOrderMobile";
	    ILLUSTRATION_COMPONENTS["WholesaleOrderWeb"] = "WholesaleOrderWeb";
	    ILLUSTRATION_COMPONENTS["Woman"] = "Woman";
	    ILLUSTRATION_COMPONENTS["WrittenPlanMobile"] = "WrittenPlanMobile";
	    ILLUSTRATION_COMPONENTS["Yield"] = "Yield";
	    return ILLUSTRATION_COMPONENTS;
	}({});

	illustrations.__exports.ILLUSTRATION_COMPONENTS = ILLUSTRATION_COMPONENTS;
	
	return illustrations.__exports;
}

exports.__require = requireIllustrations;
//# sourceMappingURL=illustrations.cjs.map
